import { isCallState } from "./types.js";
function ProductHighlightPart({
  part,
  allParts
}) {
  if (isCallState(part.state)) return null;
  if (allParts.some((p) => p.type === "data-product-highlight")) return null;
  return null;
}
export {
  ProductHighlightPart
};
//# sourceMappingURL=ProductHighlightPart.js.map
